export const buildSelfVerificationUrl = (accountUrl: string, email: string, raffleId: string) =>
  `${accountUrl}/self-verification/${email}?raffleId=${raffleId}`;

// wa.me necesita el número internacional solo con dígitos
export const toWhatsappPhone = (phone: string, defaultPrefix: string) => {
  const trimmed = phone.trim();
  const digits = trimmed.replace(/\D/g, "");
  if (trimmed.startsWith("+")) return digits;
  if (trimmed.startsWith("00")) return digits.slice(2);
  return defaultPrefix.replace(/\D/g, "") + digits.replace(/^0+/, "");
};

export const buildWhatsappUrl = (phone: string, text: string) =>
  `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;

interface TicketsMessageParams {
  purchaserName: string;
  raffleName: string;
  tickets: string[];
  isPaid: boolean;
  link: string;
}

export const buildTicketsWhatsappMessage = ({ purchaserName, raffleName, tickets, isPaid, link }: TicketsMessageParams) => {
  const status = isPaid ? "Pagados" : "Apartados";
  const voucherHint = isPaid ? "" : " En ese link adjunta tu comprobante de pago para validar tu compra.";
  return `Hola ${purchaserName}, estos son tus números de la rifa ${raffleName}: ${tickets.join(", ")} (${status}). Revísalos en: ${link}.${voucherHint}`;
};
